import { getLocalizedString } from '@grandvisionhq/utils';

const getProductTags = (serverTags, price, locale)=>{
    const zeroDiscount = getZeroDiscountValue(price, locale);
    if (!serverTags.length && !zeroDiscount) return undefined;
    if (serverTags.length) {
        var _key;
        return serverTags.map((serverTag)=>({
                key: (_key = serverTag.key) !== null && _key !== void 0 ? _key : undefined,
                value: serverTag.value
            })
        );
    }
    // When a product has a discount of zero, and no other product tags are defined, use this as a fallback product tag
    return [
        {
            key: '',
            value: zeroDiscount || ''
        }, 
    ];
};
const getZeroDiscountValue = (price, locale)=>{
    const { discountedPrice  } = price;
    if (!discountedPrice || !discountedPrice.discountInformation) return undefined;
    const { value , description , name  } = discountedPrice.discountInformation;
    if (!description || value !== 0) return null;
    return getLocalizedString(name, locale);
};

export { getProductTags };
//# sourceMappingURL=get-product-tags.js.map
